<template>
    <div class="max-width-content">
        <trashed-message v-if="company.deleted_at" class="mb-6" @restore="restore">
            This company has been deleted.
        </trashed-message>

        <breadcrumbs>
            <inertia-link href="/companies">Bedrijven</inertia-link>
            <i class="fad fa-chevron-right"></i>
            <inertia-link :href="route('admin.companies.show', company.id)">{{ company.name | truncate(35) }}</inertia-link>
            <i class="fad fa-chevron-right"></i>
            Wijzig
        </breadcrumbs>

        <div class="mt-5 bg-white rounded-lg px-8 py-5">
            <company-form :company="company" @submit="submit" :data-loading="loading"></company-form>
        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import TrashedMessage from "@/admin/Shared/TrashedMessage";
import CompanyForm from "@/admin/Pages/Companies/CompanyForm";

export default {
    metaInfo() {
        return { title: this.company.name };
    },

    layout: (h, page) => h(Layout, [page]),

    components: {
        TrashedMessage,
        Breadcrumbs,
        CompanyForm
    },

    mixins: [Helpers],

    props: {
        company: Object
    },

    remember: "form",

    data() {
        return {
            form: {
                name: this.company.name,
                image: null,
                description: this.company.description,
                seotext1: this.company.seotext1,
                seotext2: this.company.seotext2
            }
        };
    },

    methods: {
        submit(data) {
            this.loading = "submit";

            const url = this.route("admin.companies.update", this.company.id).url();

            data.append("_method", "patch");
            const options = {
                onFinish: () => {
                    this.loading = false;
                    if (Object.keys(this.$page.props.errors).length === 0) {
                        this.form.image = null;
                    }
                }
            }
            this.$inertia.post(url, data, options)
        },

        destroy() {
            this.loading = "delete";
            if (confirm("Are you sure you want to delete this company?")) {
                this.$inertia.delete(this.route("admin.companies.destroy", this.company.id))
            }
        },

        restore() {
            this.loading = "restore";
            if (confirm("Are you sure you want to restore this company?")) {
                this.$inertia.patch(this.route("admin.companies.restore", this.company.id))
            }
        }
    }
};
</script>
